import type { Cta } from './types';

export const heroContent = {
    headline: "Elevating the Kingdom's Plate with Global Excellence",
    description:
        "Bridging the world’s finest pastures to the Gulf’s premier tables, we deliver a sophisticated portfolio of premium bovine and ovine cuts tailored to the region's top-tier market demands. Rooted in absolute Halal integrity and backed by advanced cold-chain technology, our distribution network ensures flawless quality, strict safety compliance, and reliable supply. We don’t just import meat; we deliver culinary excellence and supply-chain trust to the heart of the Gulf’s food sector.",
    ctas: [
        { label: 'Contact Us', href: '/contact', className: 'btn-primary' },
        { label: 'Explore Our Origins', href: '#origins', className: 'btn-secondary' },
    ] satisfies Cta[],
};
